import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login'
import Home from '@/views/Home'
import Search from '@/views/Search'
import Homepage from '@/views/Homepage'
import Warehousing from '@/views/Warehousing'
import StorOut from '@/views/StockOut'
import Staff from '@/views/Staff'
import Customer from '@/views/Customer'
import Searcha from '@/views/Searcha'
import remarkList from '@/views/Remark'
import Role from '@/views/Role'
import custManagement from '@/views/CustomerManagement'
import TaskList from '@/views/TaskList'
import excelExport from '@/views/ExcelExport'

import feedBackList from '@/views/FeedBackList'
import stockAdjList from '@/views/StockAdjustMent'
import feedBack from '@/views/FeedBack'
import updateFeedBack from '@/views/UpdateFeedBack'

import rollingList from '@/views/RollingList'
import rolling from '@/views/Rolling'
import updateRolling from '@/views/UpdateRolling'
import calendarList from '@/views/TaskCalendar'

import calenTaskList from '@/views/CalendarList'
import jobOrderList from '@/views/JobOrderList'

import addJobOrder from '@/views/AddJobOrder'
import updateJobOrder from '@/views/UpdateJobOrder'

import addStockIn from '@/views/AddStockIn'
import updateStockIn from '@/views/UpdateStockIn'
import addStockOut from '@/views/AddStockOut'
import updateStockOut from '@/views/UpdateStockOut'
import jobPrinting from '@/views/JobPrinting'

import itemStor from '@/views/ItemStor'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            hidden: true,
            children:[]
        },
        {
            path: '/',
            name: '倉庫一覽',
            component: Home,
            hidden: true,
            children:[
                {
                    path: 'customer/:id',
                    name: '客戶詳情',
                    component: Search,
                    hidden: true,
                    children:[]
                },
                {
                    path: 'stockin/',
                    name: '入倉',
                   component: Warehousing,
                    hidden: true,
                    children:[]
                },
                {
                    path: 'addStockin/',
                    name: '新增入倉',
                    component: addStockIn,
                    hidden: true,
                    children:[]
                },
                {
                    path: 'updateStockin/:id/:typeId/:custId',
                    name: '編輯入倉',
                    component: updateStockIn,
                    hidden: true,
                    children:[]
                },
                {
                    path: 'stockout/',
                    name: '出倉',
                    component: StorOut,
                    hidden: true,
                    children:[]
                },
                {
                    path: 'addStockout/',
                    name: '新增出倉',
                    component: addStockOut,
                    hidden: true,
                    children:[]
                },
                {
                    path: 'updatesStockout/:id/:typeId/:custId',
                    name: '編輯出倉',
                    component: updateStockOut,
                    hidden: true,
                    children:[]
                },
                {
                    path: 'page/',
                    name: '倉庫一覽',
                    component: Homepage,
                    hidden: true,
                    children:[]
                },
                {
                    path: 'staff/',
                    name: '員工',
                   component: Staff,
                    hidden: true,
                    children:[]
                },
                {
                    path: 'customer/',
                    name: '客戶',
                    component: Customer,
                    hidden: true,
                    children:[]
                },
                {
                    path: 'customer/:keywords',
                    name: '首頁搜尋網頁面',
                    component: Searcha,
                    hidden: true,
                    children:[]
                },
                {
                    path:'remark/',
                    name: '常用備註',
                    component: remarkList,
                    hidden: true,
                    children: []
                },
				
                {
                    path: 'role/',
                    name: '角色',
                    component: Role,
                    hidden: true,
                    children: []
                },
                {
                    path: 'custgrp/',
                    name: '客戶組',
                    component: custManagement,
                    hidden: true,
                    children: []
                },
                {
                    path: 'task/',
                    name: '任務列表',
                    component: TaskList,
                    hidden: true,
                    children: []
                },
                {
                    path: 'reports/',
                    name: '報表',
                    component: excelExport,
                    hidden: true,
                    children: []
                },
                {
                    path: 'materialin/',
                    name: '回料紙',
                    component:feedBackList,
                    hidden: true,
                    children: []
                },
                {
                    path: 'feedAdd',
                    name: '新增回料紙',
                    component: feedBack,
                    hidden: true,
                    children: []
                },
                {
                    path: 'feedEdit/:feedId/:rollId',
                    name: '編輯回料紙',
                    component: updateFeedBack,
                    hidden: true,
                    children: []
                },{
                    path: 'materialout/',
                    name: '物料出入倉',
                    component:rollingList,
                    hidden: true,
                    children: []
                },
                {
                    path: 'rollAdd',
                    name: '新增出倉紙',
                    component: rolling,
                    hidden: true,
                    children: []
                },
                {
                    path: 'rollEdit/:outId',
                    name: '編輯出倉紙',
                    component: updateRolling,
                    hidden: true,
                    keepAlive:true,
                    children: []
                },
                {
                    path: 'stockAdj/',
                    name: '貨品調整',
                    component: stockAdjList,
                    hidden: true,
                    children: []
                },
                {
                    path: 'taskCalendar/',
                    name: '行事曆',
                    component:calendarList,
                    hidden: true,
                    children: []
                },
                {
                    path: 'calenList/',
                    name: '行事曆列表',
                    component:calenTaskList,
                    hidden: true,
                    children: []
                },
                {
                    path: 'jobOrder/',
                    name: '工作單',
                    component:jobOrderList,
                    hidden: true,
                    children: []
                },
                {
                    path: 'jobAdd',
                    name: '新增工作單',
                    component: addJobOrder,
                    hidden: true,
                    children: []
                },
				{
				    path: 'jobPrint/:id/:jobId',
				    name: '卡板箱号管理',
				    component: jobPrinting,
				    hidden: true,
				    children: []
				},
                {
                    path: 'jobEdit/:jobId',
                    name: '編輯工作單',
                    component: updateJobOrder,
                    hidden: true,
                    children: []
                },
                {
                    path: 'itemStor/',
                    name: '產品倉存',
                    component: itemStor,
                    hidden: true,
                    children: []
                },
            ]
        }
    ]
})

export default  router;




// WEBPACK FOOTER //
// ./src/router/router.js